module.exports = __webpack_public_path__ + "2c8ae3b9bf95bca78dd6245688967809.glb";